<br>
<div class="container">
    <div class="card">
        <div class="card-content">
            <p class="title">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                Error nihil, molestiae consequuntur similique recusandae, ad odio dolorem minima,
                praesentium accusantium corporis fuga harum ratione rerum consectetur!
                Mollitia odio earum veritatis.
            </p>
            <p class="subtitle">
                John Doe
            </p>
        </div>
        <footer class="card-footer">
            <p class="card-footer-item">
                <span>
                    View on <a href="https://twitter.com/codinghorror/status/506010907021828096">Twitter</a>
                </span>
            </p>
            <p class="card-footer-item">
                <span>
                    Share on <a href="#">Facebook</a>
                </span>
            </p>
        </footer>
    </div>
    <br>
    <!--Comentario-->
    <article class="media" *ngFor="let comment of comentarios; let i = index">
        <figure class="media-left">
            <p class="image is-64x64">
                <img src="https://bulma.io/images/placeholders/128x128.png">
            </p>
        </figure>
        <div class="media-content">
            <div class="content">
                <p>
                    <strong>{{ comment.nombre }} </strong> <small>{{ comment.username }} </small> <small>31m</small>
                    <br>
                    {{ comment.comentario }}
                </p>
            </div>
            <nav class="level is-mobile">
                <div class="level-left">
                    <a class="level-item">
                        <span class="icon is-small"><i class="fas fa-reply"></i></span>
                    </a>
                    <a class="level-item">
                        <span class="icon is-small"><i class="fas fa-retweet"></i></span>
                    </a>
                    <a class="level-item">
                        <span class="icon is-small"><i class="fas fa-heart"></i></span>
                    </a>
                </div>
            </nav>
        </div>
        <div class="media-right">
            <button class="delete" (click)="deleteComment(i)"></button>
        </div>
    </article>

    <br>
    <!--Generar comentario-->
    <article class="media">
        <figure class="media-left">
            <p class="image is-64x64">
                <img src="https://bulma.io/images/placeholders/128x128.png">
            </p>
        </figure>
        <div class="media-content">
            <div class="field">
                <div class="control is-loading">
                    <input class="input" type="text" [(ngModel)]="nombre" (ngModelChange)="nombre = $event"
                        placeholder="Usuario">
                </div>
            </div>
            <div class="field">
                <p class="control">
                    <textarea class="textarea" [(ngModel)]="comentario" (ngModelChange)="comentario = $event"
                        placeholder="Agrega tu comentario..."></textarea>
                </p>
            </div>
            <nav class="level">
                <div class="level-left">
                    <div class="level-item">
                        <a class="button is-info" (click)="agregarComentario()">Enviar</a>
                    </div>
                </div>
            </nav>
        </div>
    </article>
</div>